import { FC } from 'react'

import {
  CircleCheckmarkFullIcon,
  IconSizes,
  ShieldLineIcon
} from '@inno-ui/icons'
import { AuthButton, AuthButtonVariant } from 'modules/auth/components'

import { TwoFaSteps } from '../../SetupTwoFaPage.constant'
import styles from './SetupTwoFaWrapper.module.scss'
import { SetupTwoFaWrapperProps } from './SetupTwoFaWrapper.types'

export const SetupTwoFaWrapper: FC<SetupTwoFaWrapperProps> = ({
  currentStep,
  descriptionClassName = '',
  primaryButtonLabel,
  secondaryButtonLabel,
  onSecondaryButtonClick,
  onPrimaryButtonClick,
  description,
  children,
  isLoading = false,
  isDisabled = false,
  title
}) => {
  return (
    <>
      <div className={styles.setupTwoFaWrapper}>
        {currentStep === TwoFaSteps.SETUP_SUCCESS ? (
          <div className={styles.checkMarkIconWrapper}>
            <CircleCheckmarkFullIcon
              size={IconSizes.Size48}
              color='var(--white)'
            />
          </div>
        ) : (
          <div className={styles.shieldIconWrapper}>
            <ShieldLineIcon color='var(--white)' />
          </div>
        )}

        <div className={styles.textWrapper}>
          <h1 className={styles.title}>{title}</h1>
          {description && <p className={descriptionClassName}>{description}</p>}
        </div>
        {children}
        <div className={styles.buttonWrapper}>
          {primaryButtonLabel && (
            <AuthButton
              onClick={onPrimaryButtonClick}
              label={primaryButtonLabel}
              variant={AuthButtonVariant.FILLED}
              isLoading={isLoading}
              disabled={isDisabled}
            />
          )}
          {secondaryButtonLabel && (
            <AuthButton
              onClick={onSecondaryButtonClick}
              label={secondaryButtonLabel}
              variant={AuthButtonVariant.GHOST}
            />
          )}
        </div>
      </div>
    </>
  )
}
